/**
 * Acts as a stand in for a `Storage` object, mainly for cases like unit testing
 * and when static pages are built at compile time
 */
export class MemoryStorageProvider implements Storage {
  protected data: { [key: string]: string } = {};

  constructor() {
    this.getItem = this.getItem.bind(this);
    this.setItem = this.setItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.clear = this.clear.bind(this);
    this.key = this.key.bind(this);
  }

  getItem(key: string) {
    return this.data[key] ?? null;
  }

  setItem(key: string, value: string) {
    this.data[key] = value;
  }

  removeItem(key: string) {
    delete this.data[key];
  }

  clear() {
    this.data = {};
  }

  key(index: number) {
    const keys = Object.keys(this.data);

    return keys[index] ?? null;
  }

  get length() {
    return Object.keys(this.data).length;
  }
}

export const memorySessionStorage = new MemoryStorageProvider();

export const getSessionStorage = (): Storage => {
  if (typeof sessionStorage !== 'undefined') {
    return sessionStorage;
  }

  return memorySessionStorage;
};
